import { NavLink, Outlet, useNavigate, Navigate } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuth";
import { LayoutDashboard, LogOut, ExternalLink, Palmtree } from "lucide-react";
import { LOGO_URL } from "@/lib/brand";

const NAV = [
  { to: "/admin/vacanze", label: "Affitti brevi", icon: Palmtree, roles: ["amministratore", "agente", "collaboratore"] },
  { href: "/gestionale", label: "Gestionale", icon: LayoutDashboard },
];

export default function AdminLayout() {
  const { user, ready, logout } = useAdminAuth();
  const navigate = useNavigate();

  if (!ready) return <div className="min-h-screen grid place-items-center bg-warm text-anthracite/50">Caricamento…</div>;
  if (!user) return <Navigate to="/admin/login" replace />;

  const items = NAV.filter((n) => !n.roles || n.roles.includes(user.ruolo));

  return (
    <div className="min-h-screen bg-warm flex">
      <aside className="w-64 shrink-0 bg-anthracite text-white flex flex-col fixed inset-y-0 hidden md:flex">
        <div className="p-6 border-b border-white/10">
          <img src={LOGO_URL} alt="Casamore" className="h-10 w-auto brightness-0 invert" />
          <p className="text-xs text-white/40 mt-2 uppercase tracking-widest">Area riservata</p>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {items.map((n) => n.href ? (
            <a key={n.href} href={n.href} className="flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium text-white/70 hover:bg-white/10"><n.icon className="h-4 w-4" /> {n.label}</a>
          ) : (
            <NavLink key={n.to} to={n.to} end={n.end}
              className={({ isActive }) => `flex items-center gap-3 rounded-xl px-4 py-3 text-sm font-medium transition-colors ${isActive ? "bg-brand text-white" : "text-white/70 hover:bg-white/10"}`}
              data-testid={`adminnav-${n.label.toLowerCase()}`}>
              <n.icon className="h-4 w-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm text-white/70 hover:bg-white/10"><ExternalLink className="h-4 w-4" /> Vedi il sito</a>
          <div className="px-4 py-2 text-xs text-white/40">{user.nome} · {user.ruolo}</div>
          <button onClick={() => { logout(); navigate("/admin/login"); }} className="w-full flex items-center gap-3 rounded-xl px-4 py-2.5 text-sm text-white/70 hover:bg-white/10" data-testid="admin-logout"><LogOut className="h-4 w-4" /> Esci</button>
        </div>
      </aside>
      <main className="flex-1 md:ml-64 p-6 lg:p-10">
        <Outlet />
      </main>
    </div>
  );
}
